import styled from 'styled-components';
import FadeSpinner from './FadeSpinner';

const ListStyled = styled.ul`
  * + * {
    margin-top: 1em;
  }
  
  margin: auto;
  padding: 0;
  list-style: none;
`

function List({data, Comp, loading}) {


  if(loading) {
    return <FadeSpinner loading={loading}/>
  }

  if(!loading && data !== undefined) {
    return (
      <ListStyled>
          {
            data.map((item, index) =>
              <Comp key={index} item={item}/>)
          }
      </ListStyled>
    )
  }
}

export default List